import { render, staticRenderFns } from "./BoxedText.vue?vue&type=template&id=ea6091da&"
import script from "./BoxedText.vue?vue&type=script&lang=js&"
export * from "./BoxedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports